<button class="btn btn-danger" *ngIf="deviceDetector.isDesktop()" (click)="downloadPass()">Download Mobile Pass </button>
<ng-container *ngIf="deviceDetector.isMobile()">
  <button class="btn btn-android" *ngIf="deviceDetector.os.toUpperCase() === 'ANDROID'" (click)="downloadPass()"><img src="assets/images/passes/google.svg"></button>
  <button class="btn" *ngIf="deviceDetector.os.toUpperCase() === 'IOS'" (click)="downloadPass()"><img src="assets/images/passes/apple.svg"></button>
</ng-container>
